import React, { useEffect } from "react";
import { useLabelData } from "./hooks";
import { setBasicDialogOpenFor, setErrorMsg as clearStoreErrorMsg } from "../../../../store/helpers/helperReducers";
import { Sheet } from "../../../ui/sheet";
import { Button } from "../../../ui/button";
import { InputField } from "../../../Shared/Radix/Inputs/InputField";

const AddLabel: React.FC = () => {
  const { dispatch, submitHandler, labelStatus, labelData, setLabelData, errorMsg, setErrorMsg } = useLabelData();

  useEffect(() => {
    setErrorMsg({});
    dispatch(clearStoreErrorMsg({ labelName: "" }));
  }, []);

  const handleChange = (name: string, value: string) => {
    setLabelData({ ...labelData, [name]: value });
    setErrorMsg({ ...errorMsg, [name]: "" });
  };

  const handleClose = () => {
    dispatch(setBasicDialogOpenFor(undefined));
  };

  const isDiabledSave = !labelData?.labelName || labelStatus.isLoading;

  const footer = (
    <>
      <Button variant="outline" onClick={handleClose} disabled={labelStatus.isLoading}>
        Cancel
      </Button>
      <Button onClick={submitHandler} disabled={isDiabledSave}>
        Save
      </Button>
    </>
  );

  return (
    <Sheet open={true} onClose={handleClose} title="Add Label" footer={footer} width="520px">
      <form autoComplete="off">
        <div className="space-y-5 pt-2">
          <div>
            <InputField
              label="Label Name"
              name="labelName"
              disabled={labelStatus.isLoading}
              value={labelData?.labelName}
              onChange={handleChange}
              maxLength={25}
              pattern={/^[A-Za-z0-9 _.\-]{1,50}$/}
              placeholder="Enter label name"
              required
              tooltipText="Maximum length: 25 characters"
               autoFocus={true}
            />
          </div>
        </div>
      </form>
    </Sheet>
  );
};

export default AddLabel;
